import { NextPageContext } from 'next';

export default ({ res }: NextPageContext, redirectUrl: string) => {
  if (res) {
    res.setHeader('Location', redirectUrl);
    res.statusCode = 302;
    res.end();
  } else {
    document.location.pathname = redirectUrl;
  }
};
